import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { SingleCategoryPageContextStart } from "../Context/SingleCategoryPageContext";


export default function Footer() {
    const { setCategoryDetail } = useContext(SingleCategoryPageContextStart);

    const settingCategoryPageContextValue = (categoryName) => {
        setCategoryDetail(categoryName);
        localStorage.setItem("category", categoryName);
    }

    return (
        <div className="container-fluid footer">
            <div className="row">
                <div className="col-12 footer-1">
                    <h4 className='fw-light text-center'>Connect with Us</h4>
                    <div className="social-icons pt-3 d-flex justify-content-center align-items-center">
                        <a href="#" className="social-icon d-flex justify-content-center align-items-center">
                            <i className="fa-brands fa-square-facebook"></i>
                        </a>
                        <a href="#" className="social-icon d-flex justify-content-center align-items-center">
                            <i className="fa-brands fa-twitter"></i>
                        </a>
                        <a href="#" className="social-icon d-flex justify-content-center align-items-center">
                            <i className="fa-brands fa-instagram"></i>
                        </a>
                        <a href="#" className="social-icon d-flex justify-content-center align-items-center">
                            <i className="fa-brands fa-youtube"></i>
                        </a>
                        <a href="#" className="social-icon d-flex justify-content-center align-items-center">
                            <i className="fa-brands fa-google"></i>
                        </a>
                    </div>
                </div>
            </div>
            <div className="row footer-2 gap-md-0 gap-4 justify-content-center">
                <div className="col-md text-center text-sm-start mb-md-0 mb-4 col-sm-5">
                    <h5 className='mb-3 mb-sm-4 fw-normal'>Product Links</h5>
                    <div className="footer-links m-0 p-0">
                        <Link to="/all-products">All Products</Link>
                        <Link to="/sofa">Sofa</Link>
                        <Link to="/chair">Chair</Link>
                        <Link to="/table">Table</Link>
                    </div>
                </div>
                <div className="col-md text-center text-sm-start mb-md-0 mb-4 col-sm-5">
                    <h5 className='mb-3 mb-sm-4 fw-normal'>Chairs</h5>
                    <div className="footer-links m-0 p-0">
                        <Link to="/chair">Chair</Link>
                        <Link to="/category" onClick={() => { settingCategoryPageContextValue("Armchair") }}>Armchair</Link>
                        <Link to="/sofa">Recliner</Link>
                        <Link to="/category" onClick={() => { settingCategoryPageContextValue("Stool") }}>Stool</Link>
                    </div>
                </div>
                <div className="col-md text-center text-sm-start mb-md-0 mb-4 col-sm-5">
                    <h5 className='mb-3 mb-sm-4 fw-normal'>Table</h5>
                    <div className="footer-links m-0 p-0">
                        <Link to="/category" onClick={() => { settingCategoryPageContextValue("Study table") }}>Study table</Link>
                        <Link to="/table">Table</Link>
                        <Link to="/category" onClick={() => { settingCategoryPageContextValue("Computer table") }}>Computer table</Link>
                    </div>
                </div>
                <div className="col-md text-center text-sm-start mb-md-0 col-sm-5">
                    <h5 className='mb-3 mb-sm-4 fw-normal have-question'>Have Questions?</h5>
                    <a className='btn rounded-0 header-home-page-btn'>
                        Contact Us
                    </a>
                </div>
            </div>
            <div className="row">
                <div className="col-12 footer-3">
                    <p className='text-center m-0 p-0'>
                        Copyright © 2023 Furniture Store | <Link to="https://github.com/adilcodes" class="footer-bottom-link">Made By Adil Sheikh</Link>
                    </p>
                </div>
            </div>
        </div>
    )
}
